export const handleModalClose= (reason: string) => 
    ['escapeKeyDown','escapeKeyDown'].includes(reason) 
        ? false
        : true;
